module.exports = __webpack_public_path__ + "static/media/icon_send.6fad1921.svg";